import { useState } from "react";
import Datatable from "../../../../components/Datatable/Datatable";
import peticionBack from "../../../../libs/peticiones/peticionBack";
import { Badge, toaster } from "rsuite";
import createURL from "../../../../libs/peticiones/url";

export default function Sentencias() {
    const [refresh, setRefresh] = useState<boolean>(false);

    async function getData(order: string, records: number, page: number, search: string) {
        const url = createURL(`/reportes/files/public`, [
            { name: "order", value: order },
            { name: "records", value: records },
            { name: "page", value: page },
            { name: "search", value: search },
        ]);
        let res = await peticionBack({}, url, "GET", false, toaster);
        if(res){
            if(Array.isArray(res)){
                res = res[0];
            }
            res.data = [...res.rows];
            delete res.rows;
        }
        return res;
    }

    /* TABLA */
    const columns = [
        { data: "area", render: (area: string) => <p style={{ width: "500px" }}>{area}</p> },
        { data: "folderType", render: (folderType: string) => <p style={{ minWidth: "150px" }}>{folderType}</p> },
        { data: null, render: (row: any) => row.number ? `${row.number}/${row.year}` : "S/N", orderValue: "" },
        { data: "src", render: (src: string) => src.includes("http") ? <a href={src}>{src}</a> : <p style={{ maxWidth: "300px" }}>{src}</p> },
        { data: "publish", render: (p: string) => <Badge color={p === "SI" ? "blue" : "violet" } content={p} className="py-1" style={{ width: "30px" }} />},
    ];

    const columnDefs = [{ className: "text-center", targets: [1, 2, 4] }];

    return (
        <>
            <div className="d-flex flex-column flex-md-row justify-content-md-between mb-2">
                <h4 className="">Sentencias Publicadas / No Publicadas</h4>
            </div>
            <Datatable columns={columns} headers={["Juzgado", "Carpeta", "Número", "Url", "Publicado"]} columnDefs={columnDefs} petition={getData} control="back" order={{ col: 0, opt: "desc" }} stateRefresh={[refresh, setRefresh]} className="p-0" />
        </>
    );
}
